// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Data
import CustomPageLayout from "examples/LayoutContainers/CustomPageLayout";
import { Grid } from "@mui/material";
import AddEditSuperAdminForm from "components/SuperAdmin/addEditForm";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { getSuperAdminUserById } from "lib/Api/SuperAdminUsers";
import { LoginFormContext } from "context/loginFormCtx";

function EditSuperAdminUser() {
  const { id } = useParams();
  const { setNotification } = useContext(LoginFormContext);
  const [superAdminData, setSuperAdminData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSuperAdminUser = async () => {
      try {
        const response = await getSuperAdminUserById(id);
        if (response.status === 200) {
          setSuperAdminData(response.data.data);
        } else {
          setNotification({
            color: "error",
            icon: "warning",
            title: "Error",
            content: "Failed to fetch super admin user data",
            open: true,
          });
        }
      } catch (error) {
        console.error("Error fetching super admin user:", error);
        setNotification({
          color: "error",
          icon: "warning",
          title: "Error",
          content: "An error occurred while fetching user data",
          open: true,
        });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchSuperAdminUser();
    }
  }, [id, setNotification]);

  return (
    <CustomPageLayout>
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1}>
            <Grid container justifyContent="space-between" spacing={3}>
              <Grid item>
                <MDTypography variant="h5" fontWeight="medium">
                  Edit Super Admin User
                </MDTypography>
                <MDTypography variant="button" color="text">
                  Here you can edit the super admin user details.
                </MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox p={3} lineHeight={1}>
            {!loading && superAdminData && <AddEditSuperAdminForm superAdminData={superAdminData} />}
            {!loading && !superAdminData && (
              <MDTypography variant="body1" color="text">
                User not found or you don't have permission to edit this user.
              </MDTypography>
            )}
          </MDBox>
        </Card>
      </MDBox>
    </CustomPageLayout>
  );
}

export default EditSuperAdminUser; 